export const ACTIVITY_KEY = "vivo_last_activity";
export const LOGOUT_KEY = "vivo_session_logout";
export const EXPIRED_FLAG = "vivo_session_expired";

export const readExpiredFlag = () => { try { return !!sessionStorage.getItem(EXPIRED_FLAG); } catch { return false; } };
export const clearExpiredFlag = () => { try { sessionStorage.removeItem(EXPIRED_FLAG); } catch {} };

export const markActivity = () => { try { localStorage.setItem(ACTIVITY_KEY, String(Date.now())); } catch {} };
export const clearActivity = () => { try { localStorage.removeItem(ACTIVITY_KEY); } catch {} };
export const lastActivity = () => Number(localStorage.getItem(ACTIVITY_KEY)) || 0;
